import { Action } from '@ngrx/store';
import { OfferDetailsInterface } from '../../../shared/models/offer-details.interface';

export enum EOfferDetailsActions {
  GetOfferDetails = '[OFFER_DETAILS] Get offer details',
  GetOfferDetailsSuccess = '[OFFER_DETAILS] Get offer details success',
  GetOfferDetailsFailure = '[OFFER_DETAILS] Get offer details failure',
}

export class GetOfferDetails implements Action {
  public readonly type = EOfferDetailsActions.GetOfferDetails;
  constructor(public offerId: number) {}
}

export class GetOfferDetailsSuccess implements Action {
  public readonly type = EOfferDetailsActions.GetOfferDetailsSuccess;
  constructor(public payload: OfferDetailsInterface) {}
}

export class GetOfferDetailsFailure implements Action {
  public readonly type = EOfferDetailsActions.GetOfferDetailsFailure;
}

export type OfferDetailsActions = GetOfferDetails | GetOfferDetailsSuccess | GetOfferDetailsFailure;
